var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 344,
    viewBox: "0 0 340 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M223.768 308.906L144.169 332.714L146.131 333.786L158.876 329.976L174.344 339.047L161.599 342.856L163.549 343.928L245.205 319.501L245.086 319.429C245.359 319.429 245.633 319.418 245.894 319.394L338.536 311.156C340.094 311.013 340.545 308.966 339.19 308.18L190.561 222.258C188.362 220.984 185.829 220.424 183.297 220.651L89.466 228.995C88.4078 229.09 88.1106 230.483 89.0261 231.007L144.561 263.112L126.668 273.456C121.698 276.325 159.661 301.014 159.661 301.014C161.765 301.038 165.284 301.038 167.389 301.014C170.563 300.99 173.726 300.276 176.151 298.871L191.275 290.122L223.768 308.906ZM170.884 326.393L186.352 335.464L178.315 337.869L162.847 328.798L170.884 326.393ZM182.904 322.798L198.373 331.869L190.312 334.274L174.843 325.203L182.904 322.798ZM194.913 319.203L210.381 328.274L202.344 330.679L186.875 321.608L194.913 319.203ZM206.921 315.608L222.389 324.679L214.352 327.084L198.884 318.013L206.921 315.608ZM218.941 312.013L234.409 321.084L226.348 323.489L210.88 314.418L218.941 312.013ZM225.659 310.002L239.426 317.965C240.128 318.37 240.865 318.691 241.614 318.93L238.238 319.941L222.769 310.871L225.647 310.013L225.659 310.002Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M44.8945 266.529V264.672H66.9017L70.3615 266.529H69.4698L129.071 300.979H129.713L133.173 302.836H107.718V300.979H110.583L50.9819 266.529H44.8945Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.608 281.073L152.324 296.036C157.282 298.917 165.355 298.917 170.349 296.036L202.462 277.466V280.347L170.349 298.917C165.367 301.798 157.282 301.798 152.324 298.917L126.608 283.954C124.147 282.513 122.91 280.644 122.91 278.764V275.883C122.91 277.764 124.135 279.633 126.608 281.073Z",
    fill: "url(#paint0_linear_8342_75092)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.668 270.621L158.781 252.051L202.463 277.466L170.349 296.036C165.368 298.917 157.283 298.917 152.325 296.036L126.608 281.073C121.639 278.18 121.686 273.502 126.668 270.621Z",
    fill: "#FFF7F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.497 248.493L152.637 223.078L150.461 224.864L194.321 250.291L196.497 248.493Z",
    fill: "#FFF7F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.321 250.29L150.461 224.863L156.358 253.326L200.218 278.752L194.321 250.29Z",
    fill: "#D9D4D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.496 248.492L194.32 250.29L200.217 278.752L202.488 277.443L196.496 248.492Z",
    fill: "#AEA6BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M179.791 293.465L179.779 290.584L136.098 265.169L158.783 252.051L202.464 277.466L202.476 280.346L179.791 293.465Z",
    fill: "#ADA4B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6013 42.1024C70.5049 41.7929 71.5512 41.912 72.6093 42.5191L258.618 150.047C261.139 151.5 262.768 155.226 262.245 158.368L238.989 299.942C238.692 301.763 237.741 302.977 236.504 303.406L234.887 303.965C236.124 303.537 237.075 302.323 237.372 300.501L260.628 158.928C261.139 155.785 259.522 152.071 257.001 150.607L70.9924 43.0786C69.9342 42.4596 68.8761 42.3524 67.9844 42.6619L69.6013 42.1024Z",
    fill: "url(#paint1_linear_8342_75092)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2304 187.687L65.486 46.1132C65.9972 42.9706 68.4583 41.6135 70.9789 43.0777L256.988 150.606C259.508 152.058 261.137 155.784 260.614 158.927L237.359 300.5C236.847 303.643 234.386 305 231.866 303.536L45.8686 196.008C43.348 194.555 41.7192 190.829 42.2423 187.687H42.2304Z",
    fill: "#243587"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.887 303.633L35.1649 190.498C32.7394 189.093 30.7539 185.962 30.7539 183.51V44.3293C30.7539 43.1984 31.17 42.3294 31.931 41.889C32.8345 41.3652 34.1067 41.5081 35.4383 42.2818L231.149 155.417C233.574 156.821 235.56 159.952 235.56 162.404V301.585C235.56 302.716 235.144 303.585 234.383 304.026C234.026 304.228 233.61 304.335 233.146 304.335C232.457 304.335 231.672 304.097 230.876 303.633H230.887ZM32.2163 42.377C31.6337 42.7103 31.3127 43.4127 31.3127 44.3293V183.51C31.3127 185.784 33.1674 188.7 35.4383 190.01L231.149 303.145C232.302 303.811 233.372 303.954 234.098 303.538C234.68 303.204 235.001 302.514 235.001 301.585V162.404C235.001 160.131 233.146 157.214 230.876 155.905L35.1649 42.758C34.4515 42.3413 33.7619 42.1271 33.1674 42.1271C32.8108 42.1271 32.4898 42.2104 32.2163 42.3651V42.377Z",
    fill: "#455FDC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.364 174.427V303.858C231.364 306.215 229.45 307.025 227.096 305.668L31.3855 192.521C29.0314 191.152 27.1172 188.14 27.1172 185.783V56.3516L231.364 174.427Z",
    fill: "#FFF7F5",
    stroke: "#102484",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.082 57.0545V47.4361C27.082 45.0791 28.9962 44.2696 31.3503 45.6267L227.156 158.809C229.51 160.178 231.424 163.19 231.424 165.547V175.165L27.082 57.0545Z",
    fill: "#435CD5",
    stroke: "#22367F",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.57 275.337L176.508 276.444V272.207L192.155 281.254V285.48L194.105 286.551V221.246L192.167 220.127V229.817L176.52 220.77V211.08L174.582 209.961V275.349L174.57 275.337ZM176.508 239.495L192.155 248.542V262.541L176.508 253.494V239.495ZM192.155 232.162V246.185L176.508 237.138V223.115L192.155 232.162ZM176.508 269.85V255.851L192.155 264.898V278.897L176.508 269.85Z",
    fill: "#ADA4B8"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.871 333.797L147.976 333.32L152.434 314.227L150.33 314.703L145.871 333.797Z",
    fill: "#ADA4B8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.922 312.11L153.038 311.646L156.629 296.23L154.524 296.707L150.922 312.11Z",
    fill: "#ADA4B8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.449 321.084L168.554 320.608L153.038 311.645L150.922 312.109L166.449 321.084Z",
    fill: "#F1E9F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.133 294.111L157.237 293.646L160.84 278.207L158.735 278.683L155.133 294.111Z",
    fill: "#ADA4B8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.648 303.084L172.765 302.608L157.237 293.645L155.133 294.109L170.648 303.084Z",
    fill: "#F1E9F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.34 276.099L161.444 275.623L165.035 260.207L162.93 260.683L159.34 276.099Z",
    fill: "#ADA4B8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M174.855 285.065L176.96 284.601L161.444 275.625L159.34 276.101L174.855 285.065Z",
    fill: "#F1E9F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.539 258.099L165.643 257.623L169.246 242.207L167.13 242.683L163.539 258.099Z",
    fill: "#ADA4B8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.055 267.065L181.171 266.601L165.643 257.625L163.539 258.101L179.055 267.065Z",
    fill: "#F1E9F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M167.734 240.103L169.851 239.627L173.453 224.199L171.337 224.663L167.734 240.103Z",
    fill: "#ADA4B8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M171.945 222.08L174.05 221.603L176.547 210.938L174.43 211.414L171.945 222.08Z",
    fill: "#ADA4B8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.429 211.413L176.545 210.937L174.405 209.699L172.289 210.175L174.429 211.413Z",
    fill: "#F1E9F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.262 249.065L185.366 248.601L169.851 239.625L167.734 240.101L183.262 249.065Z",
    fill: "#F1E9F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.473 231.053L189.577 230.577L174.05 221.602L171.945 222.078L187.473 231.053Z",
    fill: "#F1E9F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M192.085 221.616L194.19 221.14L192.061 219.914L189.957 220.378L192.085 221.616Z",
    fill: "#F1E9F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M163.516 344.001L165.62 343.525L194.19 221.141L192.086 221.617L163.516 344.001Z",
    fill: "#ADA4B8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M171.944 222.08L187.472 231.055L189.956 220.389L192.085 221.615L163.515 344L161.386 342.774L165.845 323.68L150.317 314.704L145.859 333.798L143.719 332.56L172.289 210.176L174.429 211.414L171.944 222.08ZM155.133 294.122L170.66 303.098L174.263 287.67L158.735 278.695L155.133 294.122ZM167.747 240.102L183.275 249.078L186.877 233.65L171.35 224.675L167.747 240.102ZM150.936 312.121L166.463 321.097L170.066 305.693L154.538 296.717L150.936 312.121ZM163.538 258.101L179.066 267.077L182.668 251.673L167.141 242.697L163.538 258.101ZM159.341 276.1L174.869 285.075L178.459 269.672L162.932 260.696L159.341 276.1Z",
    fill: "#DFD7E2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.707 269.697L51.1102 263.686V262.781L40.707 268.793V269.697Z",
    fill: "#ADA4B8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8672 268.053L40.7087 269.696V268.791L37.8672 267.148V268.053Z",
    fill: "#DFD7E2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7087 268.791L51.1119 262.779L48.2704 261.137L37.8672 267.148L40.7087 268.791Z",
    fill: "#FFF7F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.4414 263.922H49.1245L46.604 265.743L45.2367 266.172H43.6197L43.4414 263.922Z",
    fill: "#ADA4B8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6213 266.185L45.9754 264.828V230.414L43.0625 231.45L43.6213 266.185Z",
    fill: "#ADA4B8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4922 265.528L43.6217 266.182V231.768L42.4922 231.113V265.528Z",
    fill: "#DFD7E2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6217 231.77L45.9758 230.413L44.8344 229.758L42.4922 231.115L43.6217 231.77Z",
    fill: "#FFF7F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1914 248.088L105.41 283.478V267.289L44.1914 231.898V248.088Z",
    fill: "#DFD7E2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M105.41 267.29L106.825 266.48L45.5944 231.09L44.1914 231.899L105.41 267.29Z",
    fill: "#FFF7F5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 280.574L93.1993 276.419L85.5783 255.826L92.7713 259.98L100.392 280.574ZM64.5698 259.861L71.7628 264.015L64.1418 243.422L56.9487 239.267L64.5698 259.861ZM78.8846 268.134L86.0776 272.289L78.4565 251.695L71.2635 247.54L78.8846 268.134ZM105.41 267.277L99.8931 264.087L105.41 278.979V267.277ZM50.2431 251.576L57.4362 255.73L49.8151 235.136L44.1914 231.887V235.208L50.255 251.588L50.2431 251.576Z",
    fill: "#D62525"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M102.875 305.635L113.266 299.623V298.719L102.875 304.73V305.635Z",
    fill: "#ADA4B8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M100.035 303.991L102.877 305.633V304.729L100.035 303.086V303.991Z",
    fill: "#DFD7E2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M102.877 304.728L113.268 298.717L110.426 297.074L100.035 303.086L102.877 304.728Z",
    fill: "#FFF7F5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M105.609 299.859H111.292L108.772 301.681L107.405 302.109H105.788L105.609 299.859Z",
    fill: "#ADA4B8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M105.789 302.123L108.131 300.766V266.352L105.23 267.387L105.789 302.123Z",
    fill: "#ADA4B8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M104.648 301.453L105.79 302.12V267.706L104.648 267.039V301.453Z",
    fill: "#DFD7E2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M105.79 267.707L108.132 266.35L107.003 265.684L104.648 267.041L105.79 267.707Z",
    fill: "#FFF7F5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M175.451 155.416L220.856 181.664C221.831 182.224 222.616 183.473 222.616 184.45V191.282L222.592 212.019C222.592 212.995 221.808 213.329 220.833 212.769L175.463 186.545C174.488 185.985 173.703 184.735 173.703 183.759V162.999L173.691 156.154C173.691 155.178 174.476 154.845 175.451 155.404V155.416Z",
    fill: "#ADA4B8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M213.698 196.115V217.173C213.698 218.15 212.913 218.483 211.938 217.923L166.568 191.699C165.593 191.14 164.809 189.89 164.809 188.914V167.855L213.71 196.115H213.698Z",
    fill: "#435CD5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M164.785 168.143V161.31C164.785 160.334 165.57 160.001 166.545 160.56L211.95 186.808C212.925 187.368 213.71 188.618 213.71 189.594V196.427L164.773 168.143H164.785Z",
    fill: "#7FCBFC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M201.809 200.7L207.753 204.14V203.343L201.809 199.902V200.7Z",
    fill: "#FFF7F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M196.754 197.782L200.606 199.996V199.199L196.766 196.984L196.754 197.782Z",
    fill: "#FFF7F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M195.566 196.284L195.554 197.081L191.797 194.915V194.117L195.566 196.284Z",
    fill: "#FFF7F5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M187.934 192.676L190.597 194.212V193.415L187.934 191.879V192.676Z",
    fill: "#FFF7F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M180.965 188.641L186.719 191.974L186.731 191.177L180.965 187.855V188.641Z",
    fill: "#FFF7F5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M204.363 204.341L207.669 206.257V205.46L204.363 203.543V204.341Z",
    fill: "#FFF7F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M199.488 201.52L203.162 203.651V202.853L199.488 200.723V201.52Z",
    fill: "#FFF7F5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M198.289 200.033V200.831L195.031 198.95V198.152L198.289 200.033Z",
    fill: "#FFF7F5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M189.859 195.962L193.83 198.259V197.462L189.859 195.164V195.962Z",
    fill: "#FFF7F5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M180.953 190.809L188.657 195.261V194.464L180.953 190.012V190.809Z",
    fill: "#FFF7F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M206.836 207.938L207.74 208.462L207.751 207.664L206.836 207.141V207.938Z",
    fill: "#FFF7F5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M196.754 202.106L205.635 207.249V206.451L196.754 201.309V202.106Z",
    fill: "#FFF7F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M195.554 200.616L195.542 201.413L191.785 199.235V198.449L195.554 200.616Z",
    fill: "#FFF7F5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M187.922 196.997L190.585 198.544V197.747L187.922 196.199V196.997Z",
    fill: "#FFF7F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M180.953 192.973L186.719 196.306V195.509L180.953 192.176V192.973Z",
    fill: "#FFF7F5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M198.969 196.211L207.767 201.294V198.782L198.969 193.688V196.211Z",
    fill: "#FFF7F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M190.656 191.402L196.732 194.914V192.402L190.668 188.891L190.656 191.402Z",
    fill: "#FFF7F5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.4198 136.443L73.4381 160.62C74.413 161.18 75.1977 162.43 75.1977 163.406V170.239L75.1739 190.975C75.1739 191.951 74.3892 192.285 73.4143 191.725L32.4317 167.572C31.4567 167.013 30.672 165.763 30.672 164.787V144.026L30.6602 137.181C30.6602 136.205 31.4449 135.872 32.4198 136.431V136.443Z",
    fill: "#ADA4B8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5804 175.83V196.888C56.5804 197.864 55.7957 198.198 54.8208 197.638L9.45103 171.414C8.4761 170.854 7.69141 169.605 7.69141 168.628V147.57L56.5923 175.83H56.5804Z",
    fill: "#435CD5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66797 147.858V141.025C7.66797 140.049 8.45267 139.716 9.42759 140.275L54.8331 166.523C55.808 167.083 56.5927 168.333 56.5927 169.309V176.142L7.66797 147.858Z",
    fill: "#7FCBFC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6914 180.415L50.6361 183.855V183.057L44.6914 179.617V180.415Z",
    fill: "#FFF7F5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6367 177.497L43.4889 179.711V178.913L39.6486 176.699L39.6367 177.497Z",
    fill: "#FFF7F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4367 176.01V176.796L34.6797 174.63V173.832L38.4367 176.01Z",
    fill: "#FFF7F5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8047 172.391L33.4798 173.939V173.141L30.8166 171.594L30.8047 172.391Z",
    fill: "#FFF7F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8477 168.368L29.6021 171.701L29.614 170.903L23.8477 167.57V168.368Z",
    fill: "#FFF7F5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2461 184.055L50.5513 185.972V185.174L47.2461 183.258V184.055Z",
    fill: "#FFF7F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3711 181.247L46.0449 183.366V182.568L42.3711 180.449V181.247Z",
    fill: "#FFF7F5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1717 179.748V180.546L37.9141 178.665V177.867L41.1717 179.748Z",
    fill: "#FFF7F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7422 175.676L36.7132 177.974V177.176L32.7422 174.879V175.676Z",
    fill: "#FFF7F5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 170.536L31.5402 174.976V174.178L23.8359 169.738V170.536Z",
    fill: "#FFF7F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7188 187.653L50.6223 188.189L50.6342 187.391L49.7188 186.855V187.653Z",
    fill: "#FFF7F5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6367 181.833L48.5181 186.963V186.166L39.6367 181.035V181.833Z",
    fill: "#FFF7F5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4369 180.331L38.425 181.128L34.668 178.962V178.164L38.4369 180.331Z",
    fill: "#FFF7F5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8047 176.723L33.4679 178.259V177.461L30.8047 175.926V176.723Z",
    fill: "#FFF7F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 172.688L29.6023 176.021V175.224L23.8359 171.891V172.688Z",
    fill: "#FFF7F5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8516 175.926L50.6497 181.009V178.497L41.8516 173.402V175.926Z",
    fill: "#FFF7F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5391 171.129L39.6145 174.641V172.117L33.551 168.605L33.5391 171.129Z",
    fill: "#FFF7F5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M155.418 231.818L119.203 138.194L124.613 135.039L160.828 228.664C161.636 230.759 161.28 232.449 160.269 233.044L154.859 236.199C155.882 235.604 156.227 233.913 155.418 231.818Z",
    fill: "#C2BACA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M119.285 131.169C119.95 130.788 120.83 130.907 121.698 131.419C122.84 132.074 123.969 133.383 124.623 135.05L119.213 138.205C118.571 136.538 117.43 135.24 116.289 134.574C115.409 134.062 114.529 133.943 113.875 134.324L119.285 131.169Z",
    fill: "#DFD7E2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7335 186.333L113.341 134.801C114.007 133.884 115.148 133.908 116.289 134.563C117.431 135.218 118.56 136.527 119.214 138.193L155.429 231.818C156.713 235.151 155.073 237.46 152.481 235.961L79.6583 193.868C77.0545 192.356 75.4257 188.154 76.7454 186.333H76.7335Z",
    fill: "#D62525"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M120.556 167.344C120.057 176.605 117.298 194.771 115.158 193.544C113.018 192.306 110.26 170.951 109.761 161.106C109.154 149.047 121.162 155.987 120.556 167.344ZM111.437 198.485C111.437 200.544 113.101 203.175 115.158 204.365C117.215 205.555 118.88 204.853 118.88 202.794C118.88 200.734 117.215 198.104 115.158 196.913C113.101 195.723 111.437 196.425 111.437 198.485Z",
    fill: "#FFF7F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8342_75092",
    x1: 170.337,
    y1: 288.477,
    x2: 153.085,
    y2: 288.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADA4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD7E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8342_75092",
    x1: 216.173,
    y1: 189.557,
    x2: 210.623,
    y2: 179.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADA4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD7E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.dfc71dec5974cd3dbbd03d51b070227b.svg";
export { ForwardRef as ReactComponent };